// extracted by mini-css-extract-plugin
export default {"style":"FormulaireAxe_style__wmLQw","input":"FormulaireAxe_input__KcRwK"};